module.exports = __webpack_public_path__ + "img/security-audit-img-4.290e9b1d.webp";